import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { IUserContext } from '../store/state/IUserContext';
import { Store } from '@ngrx/store';
import * as Actions from '../store/actions';
import { MatDialog } from '@angular/material';
import { MyProfileDialogComponent } from './my-profile-dialog.component';
import { SupportTicketDialogComponent } from './support-ticket-dialog.component';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { Router } from '@angular/router';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-user-context',
  templateUrl: './user-context.component.html',
  styleUrls: ['./user-context.component.scss']
})
export class UserContextComponent implements OnInit {
  allowSupportTicketSubmissionPermission: string = 'ConfigurationModule.SupportTicket:AllowSupportTicketSubmission';
  resetPermission: string = 'CustomerModule.Users:ResetPassword';
  hasAllowSupportTicketSubmissionPermission: boolean = false;
  hasUserContextMenuPermission: string = 'CustomerModule.Users:ViewUserContextMenu'
  @Input() userContext: IUserContext;

  constructor(private store: Store<IUserContext>,
    private dialog: MatDialog,
    private currentUserService: CurrentUserService,
    private router: Router) {

    this.router.events.subscribe(res => {
      this.dialog.closeAll();
    });
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.hasAllowSupportTicketSubmissionPermission = this.currentUserService.hasPermission(this.allowSupportTicketSubmissionPermission);
  }

  logout() {
    this.store.dispatch(new Actions.LogoutAction());
    sessionStorage.clear();
  }

  changePassword() {
    this.store.dispatch(new Actions.ChangePasswordAction());
  }

  showProfile() {
    this.dialog.open(MyProfileDialogComponent,
      {
        panelClass: 'customized-full-dialog',
        width: '100vw',
        maxWidth: '100vw',
        height: 'calc(100vh - 60px)',
        data: this.userContext,
        hasBackdrop: false,
        position: {
          bottom: '0'
        }
      });
  }

  openTicket() {
    this.dialog.open(SupportTicketDialogComponent,
      {
        panelClass: 'customized-dialog',
        width: '1088px',
        data: this.userContext
      });
  }

  hasViewContextMenuPermission(): boolean{
    return this.currentUserService.hasPermission(this.hasUserContextMenuPermission);
  }
}



// WEBPACK FOOTER //
// ./src/app/security/components/user-context.component.ts